import vue from 'vue'

// 这里就是我们刚刚创建的那个静态组件
import toastComponent from './index.vue'

// 返回一个 扩展实例构造器, 关于 vue.extend 有不懂的同学,可以去查看以下官方文档 https://cn.vuejs.org/v2/api/#Vue-extend
const ToastConstructor = vue.extend(toastComponent)
// 定义弹出组件的函数 接收2个参数, 要显示的文本 和 显示时间
function tip(config,fn){

	let text = config.text || '';
	let duration = config.time || false;
	let icon = (config.icon == 'false')?false:true;
	let showWrap = true;
	let btn = config.btn || ['确定'];
	// 实例化一个 toast.vue
	const toastDom = new ToastConstructor({
		el: document.createElement('div'),
		data() {
			return {
				text: text,
				time:duration,
				icon:icon,
				btn:btn,
				showWrap: showWrap
			}
		},
		methods:{
			btnClick(index){
				this.showWrap = false;
				if(index == 0){
					fn && fn();
				}
				
			}
		}
	})

	
	if(duration){
		let timer = setInterval(() => {
			toastDom.time = toastDom.time-1;
			if(toastDom.time == 0){
				clearInterval(timer);
			}
		},1000)
	}
	

	// 把 实例化的 toast.vue 添加到 body 里
	document.body.appendChild(toastDom.$el)

	// 提前 250ms 执行淡出动画(因为我们再css里面设置的隐藏动画持续是250ms)
	//setTimeout(() => { toastDom.showContent = false }, duration - 250)
	// 过了 duration 时间后隐藏整个组件
	duration && setTimeout(() => { 
		//toastDom.showWrap = false 
		fn && fn();
		toastDom.showWrap = false;
	}, duration*1000)
}

// 注册为全局组件的函数
export function layer() {
	// 将组件注册到 vue 的 原型链里去,
	// 这样就可以在所有 vue 的实例里面使用 this.$alert()
	vue.prototype.$tip = tip;
}

export default layer;